import React, { MouseEventHandler, useContext } from "react";

import styles from "./NextButton.module.scss";
import block from 'bem-css-modules';
import { AppContext } from "../../../../util/context";

import { sanitizeContent as s } from "../../../../util/functions";

const NextButton = (props: { submitBtnText: string, stepLabel: string, handleOnClick: MouseEventHandler<HTMLButtonElement>}) => {
  const { disableButton } = useContext(AppContext);
  const {
    submitBtnText,
    stepLabel,
    handleOnClick
  } = props;

  const b = block(styles);

  return (
    <div className={`fc-submit-button ${b()}`}>
      <button type="button" onClick={handleOnClick} disabled={disableButton} className={`event-tracking-step--${stepLabel}`} >
        <span dangerouslySetInnerHTML={{ __html: s(submitBtnText) }} />
      </button>
    </div>
  )
}

export default NextButton;